import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { CustomTranslateService } from 'src/app/shared/services/custom-translate.service';

@Component({
    selector: 'app-parameter-link',
    templateUrl: './parameter-link.component.html',
    styleUrls: ['./parameter-link.component.css'],
})
export class ParameterLinkComponent implements OnInit {
    @Input() config: any;

    public isArrayValues = false;

    constructor(private customTranslateService: CustomTranslateService) {}

    ngOnInit(): void {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes['config']) {
            if (Array.isArray(this.config.value)) {
                this.isArrayValues = true;
            } else {
                this.isArrayValues = false;
            }
        }
    }

    getLocalizedValue(field: any): string {
        return this.customTranslateService.getMultilingualFieldValue(field) ?? field ?? null;
    }

    isObject(value: any): boolean {
        return value !== null && typeof value === 'object' && !Array.isArray(value);
    }

    getLabelValue(config: any): string {
        return config?.columnData?.labels?.['fr_FR'];
    }
}
